import {Component} from 'react';
import cn from 'classnames';
import styles from './Content.module.scss';
import {Modal, List, Error, Info, Finish} from "../../components";

const characters = [
        { id: 0, name: 'Свинья', desc: 'из «Подозрительной совы»', success: 4},
        { id: 1, name: 'Зубная фея', desc: 'из «Нигдегорода»', success: 5},
        { id: 2, name: 'Пришельцы', desc: 'из «Осторожно, Земляне!»', success: 2},
        { id: 3, name: 'Бурдашев', desc: 'из «Бурдашева»', success: 0},
        { id: 4, name: 'Стронций', desc: 'из «Атомного леса»', success: 3},
        { id: 5, name: 'Баба Маша', desc: 'из «9 жизней»', success: 1},
    ],
    items = [
        { id: 0, name: 'Шутки', desc: 'потому что нужны всегда', success: 3 },
        { id: 1, name: 'Кошачьи лотки', desc: 'чтобы быть во всеоружии', success: 5 },
        { id: 2, name: 'Сахар', desc: 'чтобы не закончился', success: 2 },
        { id: 3, name: 'Йод', desc: 'потому что ну очень надо', success: 4 },
        { id: 4, name: 'Пончики', desc: 'потому что вкусно', success: 0 },
        { id: 5, name: 'Зубы', desc: 'чтобы положить на полку', success: 1 }
    ],
    results = [
        { title: 'Свинья решил вкладываться в пончики, ведь они и пахнут вкусно, и красиво поблёскивают глазурью на солнце.', desc: 'Обесцениваться этот валютный актив тоже не собирался, но однажды свин выпустил внутреннего мистера Хайда и съел всю выпечку в исступлении. Кажется, хряку нужно было вкладываться в штуки, которые не получится надкусить.' },
        { title: 'Фея долгое время хранила сбережения в зубах, выкупленных у детей.', desc: 'Однако в определённый момент героиня обнаружила, что особой ценностью обладают только золотые зубы, а молочные резцы поедателей конфет можно сдать лишь по крайне невыгодному курсу!' },
        { title: 'У поп-культурных пришельцев полно слабостей: вода, огонь, лазерные лучи.', desc: 'А криптонитом инопланетян производства 2x2 оказался сахар. Ну и зачем было тратить все сбережения деда Семёна на сладкий песок, перед которым всё равно не можешь устоять?! А ещё половина инвестиций просто растаяла из-за протекающей крыши в доме землян.' },
        { title: 'Бурдашев решил вложиться в шутки, но не сразу понял, что единственное место хранения для них — его голова.', desc: 'Закрыть рот на замок не получилось, и все шутки утекли в невыдуманные истории Александра. В будущем этому господину нужно будет вложиться в чуть более материальные вещи.' },
        { title: 'Стронций вложился в йод. Но в условиях постапокалипсиса медведю приходилось постоянно опустошать заветные склянки.', desc: 'Актив таял на глазах, а ещё Стронций путал йод со своим одноимённым другом. Нужно вкладываться в штуки с названиями, которые не присвоили персонажи «Атомного леса».' },
        { title: 'Баба Маша снова оказалась обманутой вкладчицей и флешбэкнулась в девяностые от неприятных воспоминаний!', desc: 'Это собственные коты на-м-м-м-урчали ей в уши, что нужно закупать лотки. Старушка поверила и стала ждать, когда кошачьи туалеты подскочат в цене. Но у усатых были свои планы на эти… ёмкости.' }
    ];

export class Content extends Component {
    state = {
        first: null,
        second: null,
        firstElement: null,
        secondElement: null,
        match: null,
        counter: 0,
        openCard: false,
        openAllCard: false,
        modal: false,
        modalAnimate: false,
        error: false,
        errorAnimate: false,
        finish: false,
        showFinish: false,
        finishAnimate: false
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    finishGame = () => {
        if (this.state.counter === 6) {
            this.setState({ finish: true });
        }
    }

    showFinal = () => {
        this.onClickModal();
        setTimeout(() => {
            document.querySelector('.wr').classList.add(`${styles.finish}`);
            setTimeout(() => {
                this.setState({ showFinish: true }, () => {
                     setTimeout(() => {
                         document.querySelector('.finished').classList.add('header-hide');
                         this.setState({ finishAnimate: true });
                     })
                })
            }, 300);
        }, 300);
    }

    toggleState = (name) => {
        this.setState({
            [name]: !this.state[`${name}`]
        })
    };

    showError = () => {
        this.setState({errorAnimate : true}, () => {
            setTimeout(() => {
                this.state.firstElement.classList.remove(styles.true);
                this.state.secondElement.classList.remove(styles.true);
                this.state.firstElement.classList.remove(styles.false);
                this.state.secondElement.classList.remove(styles.false);

                document.querySelector(`.left`).classList.remove(styles.test);
                document.querySelector(`.right`).classList.remove(styles.test);

                this.setState({
                    first: null,
                    firstElement: null,
                    second: null,
                    secondElement: null,
                    openCard: false,
                    openAllCard: false,
                    match: false
                }, () => {
                    this.setState({errorAnimate : false});
                    setTimeout(() => {
                        this.setState({error : false});
                    }, 300);
                });
            }, 1500);
        })
    }

    showSuccess = () => {
        this.setState({
            openCard: false,
            openAllCard: false,
            modal: true,
            modalAnimate: true
        }, () => this.finishGame());
    }

    checker = (type) => {
        const currentType = type === 'left' ? this.state.first : this.state.second,
            currentElement = type === 'left' ? this.state.firstElement : this.state.secondElement;
        if (this.state.match === currentType) {
            currentElement.classList.add(styles.true);
            this.setState(({counter}) => ({counter: ++counter}), () => {
                setTimeout(() => {
                    this.showSuccess();
                }, 300);
            });
        } else {
            if (type === 'left') {
                this.state.firstElement.classList.add(styles.false);
            } else {
                this.state.secondElement.classList.add(styles.false);
            }
            this.setState({ error: true })

            setTimeout(() => {
                this.showError();
            }, 300);
        }
    }

    handlerClick = (type, value, success, e) => {
        if (!this.state.openCard) {
            const element = e.currentTarget;
            this.setState({
                [`${type === 'left' ? 'firstElement' : 'secondElement'}`]: e.currentTarget,
                [`${type === 'left' ? 'first' : 'second'}`]: value,
                match: success,
                openCard: true
            }, () => {
                document.querySelector(`.${type}`).classList.add(styles.test);
                element.classList.add(styles.true);
            });
        } else {
            const element = e.currentTarget;
            this.setState({
                [`${type === 'left' ? 'firstElement' : 'secondElement'}`]: element,
                [`${type === 'left' ? 'first' : 'second'}`]: value,
                openAllCard: true
            }, () => {
                document.querySelector(`.${type}`).classList.add(styles.test);
                this.checker(type);
            });
        }
    }

    onClickModal = () => {
        this.toggleState('modalAnimate');

        setTimeout(() => {
            this.toggleState('modal');
            setTimeout(() => {
                this.state.firstElement.classList.add(styles.hidden);
                this.state.secondElement.classList.add(styles.hidden);

                document.querySelector(`.left`).classList.remove(styles.test);
                document.querySelector(`.right`).classList.remove(styles.test);
            }, 300);
        }, 300);
    }

    generateArr = () => {
        const {first, second} = this.state;

        return {
            pics: {
                firstPic: `${process.env.PUBLIC_URL}/elements/characters/${first}.jpg`,
                secondPic: `${process.env.PUBLIC_URL}/elements/items/${second}.jpg`,
                firstName: characters[first].name,
                secondName: items[second].name
            },
            text: {
                title: results[first].title,
                desc: results[first].desc
            }
        }
    }

    render() {
        const {error, errorAnimate, modal, modalAnimate, finish, finishAnimate, showFinish} = this.state;

        return (
            <div className={cn(styles.wrapper, this.props.start ? styles.active : '', 'wr')}>
                <div className={styles.block}>
                    <List arr={characters} type="left" handler={this.handlerClick}/>
                    <List arr={items} type="right" handler={this.handlerClick} />
                </div>
                {modal ? <Block hide={!modalAnimate ? 'hide': ''} handler={finish ? this.showFinal : this.onClickModal} content={<Info handler={finish ? this.showFinal : this.onClickModal} data={this.generateArr()} link={finish}/>}/> : null}
                {error ? <Error status={error} animate={errorAnimate}/> : null}
                {finish ? <Finish show={showFinish} animate={finishAnimate}/> : null}
            </div>
        )
    }
}

const Block = ({handler, hide, content}) => {
    return <Modal show={hide} type="second" onClose={handler}>
        {content}
    </Modal>;
}